import script from "./DataMonitor.vue?vue&type=script&setup=true&lang=js"
export * from "./DataMonitor.vue?vue&type=script&setup=true&lang=js"

import "./DataMonitor.vue?vue&type=style&index=0&id=c1113c3a&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/wk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1113c3a"]])

export default __exports__